var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m1 = require("static/strategy/delect.png")

  var l0 = _vm.__map(_vm.imageList, function(t, i) {
    var m0 = _vm.$getImg(t)
    return {
      $orig: _vm.__get_orig(t),
      m0: m0
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m1: m1,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }